import React, { useEffect, useState } from "react";
import { isRight } from "src/base/Either";
import { DI, Injector } from "src/base/Injector";
import { IComnetRepository } from "src/features/comnet/data/repositories/comnetRepository";
import { IMedicalRecordComnetMaterial } from "src/features/comnet/domain/model/comnetMaterial";

interface ComnetMedicalRecordReadOnlySectionProps {
  medicalRecordId: string;
}

// 症例確認画面（閲覧専用）向けのCOMNET資料共有一覧。編集操作は一切持たない。
const ComnetMedicalRecordReadOnlySection: React.FC<ComnetMedicalRecordReadOnlySectionProps> = ({
  medicalRecordId,
}) => {
  const [shares, setShares] = useState<IMedicalRecordComnetMaterial[]>([]);

  useEffect(() => {
    if (!medicalRecordId) return;

    DI.get().injectComnetDependencies();
    const repository = Injector.get().find<IComnetRepository>("ComnetRepository");

    repository.getMedicalRecordMaterials(medicalRecordId).then((either) => {
      if (isRight(either)) {
        setShares(either.value);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicalRecordId]);

  if (shares.length === 0) return null;

  return (
    <div className="pdffile">
      {shares.map((share) => (
        <div key={share.id} className="nodeTxt d-xl-flex" style={{ minHeight: "72px", alignItems: "center" }}>
          <span className="btn btn-default btn-pdf" style={{ marginRight: "8px" }}>
            {share.material_name}
          </span>
          <span className={`badge ${share.is_shared ? "bg-success" : "bg-secondary"}`} style={{ marginRight: "8px" }}>
            {share.is_shared ? "共有中" : "非共有"}
          </span>
          {share.comment && (
            <div className="txtNotice">
              <div className="inner">
                <p>{share.comment}</p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ComnetMedicalRecordReadOnlySection;